var map = {
	"./by-nc-nd.png": 3022,
	"./by-nc-sa.png": 3232,
	"./by-nc.png": 7965,
	"./by-nd.png": 66,
	"./by-sa.png": 7956,
	"./by.png": 3713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8297;